module.exports = __webpack_public_path__ + "img/flatfare.ceb8ba9c.png";